import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import noInternet from '../../images/noInternet.png';

type ErrorProps = {
    heading?: string | boolean;
    imageSize?: number;
};

export default function SttDisabledApiError({
    heading = true,
    imageSize = 100,
}: ErrorProps) {
    const { t } = useTranslation();

    return (
        <>
            <Box display="flex" justifyContent="center" pb={2}>
                <img
                    src={noInternet}
                    alt={t('disabledApi.title')}
                    height={imageSize}
                    width={imageSize}
                />
            </Box>

            {heading && (
                <Typography variant="h5" align="center" gutterBottom>
                    {typeof heading === 'string'
                        ? heading
                        : t('disabledApi.title')}
                </Typography>
            )}

            <Typography variant="body2" align="center">
                {t('disabledApi.message')}
            </Typography>
        </>
    );
}
